import request from '../request';

// 获取课程考试列表
export const examSelectList = (query) => {
  return request({
    url: '/api/zgsource_manage/exam/selectList',
    method: 'post',
    data: query,
  });
};
// 课程考试删除/恢复
export const examDelete = (query) => {
  return request({
    url: '/api/zgsource_manage/exam/delete',
    method: 'post',
    data: query,
  });
};
// 考试保存/修改
export const examSave = (query) => {
  return request({
    url: '/api/zgsource_manage/exam/save',
    method: 'post',
    data: query,
  });
};
// 获取资源详情
export const examGetInfo = (query) => {
  return request({
    url: '/api/zgsource_manage/exam/getInfo',
    method: 'post',
    data: query,
  });
};

